// Per TD-010 (Bill 96): ship the FR file alongside EN; strings stay English
// until SDL delivers translations.
const resources = {
    pageTitle: 'Sign In'
};

export default function getResource(label) {
    return resources[label];
}
